import { put, select, take } from 'redux-saga/effects';
import { prop } from 'ramda';
import { setLocale } from 'yup/lib/customLocale';
import { REHYDRATE } from 'redux-persist';

import validationLocale from 'constants/validation';
import { postLogin } from 'actions/asyncActions';

setLocale(validationLocale);

export default function* watchAppRun() {
    yield take(REHYDRATE);
    const token = yield select(prop('token'));

    if (token) {
        yield put(postLogin.success(token));
    }
}


// WEBPACK FOOTER //
// ./src/sagas/appRun.js